import * as React from 'react';
import {
  IconSchool16,
  IconKid16,
  IconHighway16,
  IconHospital16,
  IconHouse16,
  IconMetroMsk16,
  IconRestaurant16,
  IconStore16,
  IconBus16,
  IconParking16,
  IconBike16,
  IconCompetitor16,
  IconWalk16,
  IconCar16,
  IconPolice16,
  IconMapNoCar16,
  IconInfrastructureScooter16,
  IconMapStreetcar16,
} from '@cian/ui-kit';
import { IIconProps } from '@cian/ui-kit/icons/internal';

import {
  EInsideTAInfrastructureType,
  EOutsideTAInfrastructureType,
  IRegularInfrastructureType,
  TFutureRoad,
  TMainInfrastructureType,
} from '../../types/map';

export const INFRASTRUCTURE_MAP_ICON_MAP = new Map<string, React.FunctionComponent<IIconProps>>([
  ['cafe', IconRestaurant16],
  ['clinic', IconHospital16],
  ['grocery', IconStore16],
  ['metro', IconMetroMsk16],
  ['nursery', IconKid16],
  ['futureRoad', IconHighway16],
  ['school', IconSchool16],
  ['similar_newbuilding', IconHouse16],

  [EOutsideTAInfrastructureType.busStops, IconBus16],
  [EOutsideTAInfrastructureType.tramStops, IconMapStreetcar16],
  [EOutsideTAInfrastructureType.metro, IconMetroMsk16],
  [EOutsideTAInfrastructureType.parking, IconParking16],
  [EOutsideTAInfrastructureType.bikeParking, IconBike16],
  [EOutsideTAInfrastructureType.chargingStations, IconCompetitor16],
  [EOutsideTAInfrastructureType.scooterParking, IconInfrastructureScooter16],

  [EInsideTAInfrastructureType.yardWithoutCars, IconMapNoCar16],
  [EInsideTAInfrastructureType.parking, IconParking16],
  [EInsideTAInfrastructureType.dropOffPickUpArea, IconCar16],
  [EInsideTAInfrastructureType.bikeParking, IconBike16],
  [EInsideTAInfrastructureType.chargingStations, IconCompetitor16],
  [EInsideTAInfrastructureType.scooterParking, IconInfrastructureScooter16],
  [EInsideTAInfrastructureType.boulevards, IconWalk16],
  [EInsideTAInfrastructureType.trafficSafetyElements, IconPolice16],
]);

export const ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES: string[] = [
  'main' as TMainInfrastructureType,
  'futureRoad' as TFutureRoad,
];

export const RECOMMENDED_NEWBUILDING_INFRASTRUCTURE_TYPE: IRegularInfrastructureType = {
  title: 'Похожие ЖК',
  type: 'similar_newbuilding',
};

export const INFRASTRUCTURE_MAP_SQUARE_ICON = ['similar_newbuilding'];
